import { PRESENTLEVELS_EVENT_NAMES } from '@/presentlevels/event_names.ts'
import { TEXT_EDITOR_EVENTS } from '@/components/editor/event_names.ts'
import { RESOURCE_EVENTS } from '@/resources/event_names.ts'
import { LIBRARY_EVENT_NAMES } from '@/library/library_event_names.ts'

export const EVENT_NAMES = {
  PRESENTLEVELS: { ...PRESENTLEVELS_EVENT_NAMES },
  TEXT_EDITOR: { ...TEXT_EDITOR_EVENTS },
  RESOURCES: { ...RESOURCE_EVENTS },
  MISC: {
    COPIED_TEXT: 'Copied Text'
  }, 
  LIBRARY: { ...LIBRARY_EVENT_NAMES },
}